// Permissions settings section — access groups, departments, default perms,
// dept-inheritance toggle under anchors.
//
// Layout: each section renders its own card header inside the card chrome
// (matches MembersSection pattern). No stray `<h1>` here — the settings
// shell supplies the page title + tab strip above the Outlet.
import { createFileRoute } from "@tanstack/react-router";
import { useScrollToAnchor } from "@/features/settings/hooks/use-scroll-to-anchor";
import { useCurrentOrg, useIsOrgAdmin } from "@/stores";
import AccessGroupsSection from "@/features/settings/components/access-groups-section";
import DepartmentsSection from "@/features/settings/components/departments-section";
import OrgPermSettingsCard from "@/features/settings/components/org-perm-settings-card";

function PermissionsSection() {
  useScrollToAnchor();
  const org = useCurrentOrg();
  const canEdit = useIsOrgAdmin();

  if (!org) return null;

  return (
    <div className="space-y-8">
      <section id="access-groups">
        <AccessGroupsSection canEdit={canEdit} />
      </section>

      <section id="departments">
        <DepartmentsSection orgId={org.id} canEdit={canEdit} />
      </section>

      <section id="dept-inheritance">
        <OrgPermSettingsCard />
      </section>
    </div>
  );
}

export const Route = createFileRoute("/_admin/settings/permissions")({
  component: PermissionsSection,
});
